export default "<mat-card [class.mat-card--side-line]=\"hasSideLine\">\n    <ng-content></ng-content>\n</mat-card>\n";